<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.48438 8.98438C8.48438 9.91678 8.85477 10.811 9.51408 11.4703C10.1734 12.1296 11.0676 12.5 12 12.5C12.9324 12.5 13.8266 12.1296 14.4859 11.4703C15.1452 10.811 15.5156 9.91678 15.5156 8.98438C15.5156 8.05197 15.1452 7.15776 14.4859 6.49845C13.8266 5.83914 12.9324 5.46875 12 5.46875C11.0676 5.46875 10.1734 5.83914 9.51408 6.49845C8.85477 7.15776 8.48438 8.05197 8.48438 8.98438Z"
      stroke="#272727"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 1.95312C13.8648 1.95313 15.6532 2.69392 16.9718 4.01253C18.2905 5.33115 19.0312 7.11957 19.0312 8.98438C19.0313 12.1784 14.2744 20.1875 12.5859 22.7328C12.5218 22.8295 12.4347 22.9088 12.3325 22.9637C12.2303 23.0186 12.116 23.0473 12 23.0473C11.884 23.0473 11.7697 23.0186 11.6675 22.9637C11.5653 22.9088 11.4782 22.8295 11.4141 22.7328C9.72562 20.1875 4.96875 12.1784 4.96875 8.98438C4.96875 7.11957 5.70954 5.33115 7.02816 4.01253C8.34677 2.69392 10.1352 1.95313 12 1.95312Z"
      stroke="#272727"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
